// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, anyOf } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

const result = objectOf({
  info: string,
  info_header: string,
  undo_identifier: number,
  undo_data: objectOf({
    app_group_id: string,
    segment_ids: arrayOf(string),
    type: string,
  }),
});

const undoResult = objectOf({ info: string });

export const isEngagementSegmentsMarkAsUnarchivedResult = anyOf(result, undoResult);
